<template>
	<div>
		<h4 class="mb-4 font-weight-bold text-center">Save Export</h4>

		<validation-observer ref="observer" v-slot="{ invalid }" slim>
			<b-form
				@submit.prevent="saveExport(exportItem ? exportItem.id : null)"
			>
				<b-input-group class="mt-3">
					<validation-provider rules="required" slim>
						<b-form-input
							v-model="title"
							placeholder="Title"
							class="h-50 py-2"
						></b-form-input>
					</validation-provider>
					<b-input-group-append>
						<b-button
							:disabled="invalid"
							variant="primary"
							type="submit"
							size="sm"
							class="px-4"
							>Save</b-button
						>
					</b-input-group-append>
				</b-input-group>
			</b-form>
		</validation-observer>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { ExportsService } from "@services";

export default {
	props: {
		payload: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			title: "",
		};
	},
	computed: {
		...mapGetters(["exportItem"]),
		currentUser() {
			return this.$user.get();
		},
	},
	methods: {
		async saveExport(id = null) {
			const isValid = await this.$refs.observer.validate();

			if (!isValid) return false;

			await ExportsService.saveExport(
				id,
				this.payload,
				this.title,
				this.currentUser.id
			);

			this.title = "";

			this.$toasted.show("Export report saved successfully.");
		},
	},
	watch: {
		exportItem: {
			immediate: true,
			handler(newVal) {
				this.title = newVal ? newVal.name : null;
			},
		},
	},
};
</script>
